import { User, ZERO } from '@velocity-exchange/sdk';
import { UIMarket } from '@velocity-exchange/common';
import { getHealthWithOverride } from 'src/utils/dev/devLiquidationOverrides';

export interface LowHealthWarning {
	userKey: string;
	type: 'cross' | 'isolated';
	marketIndex?: number;
	marketLabel?: string;
	health: number;
}

/**
 * Returns low-health warnings (cross and isolated) for a single user account below the threshold.
 */
export function getLowHealthWarningsForAccount(
	user: User,
	userKey: string,
	thresholdPercent: number
): LowHealthWarning[] {
	const warnings: LowHealthWarning[] = [];

	if (!user || !user.isSubscribed) return warnings;

	const crossHealth = user.getHealth();
	if (crossHealth < thresholdPercent) {
		warnings.push({
			userKey,
			type: 'cross',
			health: crossHealth,
		});
	}

	const marginCalc = user.getMarginCalculation('Maintenance');
	marginCalc.isolatedMarginCalculations.forEach((iso, marketIndex) => {
		if (iso.marginRequirement.gt(ZERO)) {
			const isolatedHealth = getHealthWithOverride(user, marketIndex, userKey);
			if (isolatedHealth < thresholdPercent) {
				const uiMarket = UIMarket.createPerpMarket(marketIndex);
				const marketLabel = uiMarket.uiSymbols.marketDisplaySymbol ?? '';
				warnings.push({
					userKey,
					type: 'isolated',
					marketIndex,
					marketLabel,
					health: isolatedHealth,
				});
			}
		}
	});

	return warnings;
}
